export default "__VITE_ASSET__BV5psQF8__"